import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-border-top",
  templateUrl: "./med-icon-border-top.component.html",
})
export class MedIconBorderTopComponent extends SvgMixinComponent {}
